import * as Intro from './Modules/Intro.js';


const preinit = () => {

}

const init = () => {
  Intro.init();
}

const resize = () => {
  Intro.resize();
}

const resizeW = () => {
  Intro.resize();
}

const scroll = () => {

}

const load = () => {
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}